import React, { useState } from 'react';
import { AiOutlineEyeInvisible, AiOutlineEye } from 'react-icons/ai';
import PropTypes from 'prop-types';

import { Container } from './styles';

const Input = ({ prefix, type, isDarkMode, ...rest }) => {
  const [passwordIsHidden, setPasswordIsHidden] = useState(true);
  const [inputType, setInputType] = useState(type || 'text');

  const handleChangePasswordViewMode = () => {
    setPasswordIsHidden(!passwordIsHidden);
    setInputType(passwordIsHidden ? 'text' : 'password');
  };

  return (
    <Container $isDarkMode={isDarkMode}>
      <input type={inputType} {...rest} autoComplete="off" />
      <span className="inputOptions">
        {prefix && <span className="prefix">{prefix}</span>}{' '}
        {type === 'password' &&
          (passwordIsHidden ? (
            <AiOutlineEyeInvisible
              className="eyePassword"
              onClick={handleChangePasswordViewMode}
            />
          ) : (
            <AiOutlineEye
              className="eyePassword"
              onClick={handleChangePasswordViewMode}
            />
          ))}
      </span>
    </Container>
  );
};

Input.propTypes = {
  prefix: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  isDarkMode: PropTypes.bool.isRequired,
};
export default Input;
